import { GENDER, MEMBER_TYPE, STATUS_SMS_OTP, TYPE_LOGIN } from '../config/constants';

export const memberTypeArray = [
  { id: MEMBER_TYPE.NORMAL, name: 'memberType', value: '普通会員.', selected: false }, // 1
  { id: MEMBER_TYPE.POINT_USER, name: 'memberType', value: 'ポイント会員.', selected: false }, // 2
  { id: MEMBER_TYPE.PLAN_USER, name: 'memberType', value: 'プラン会員.', selected: false }, // 3
];

export const sexArray = [
  // { id: 0, name: 'sex', value: '全て', selected: true },
  { id: GENDER.MALE, name: 'sex', value: '男性.', selected: false }, // 1
  { id: GENDER.FEMALE, name: 'sex', value: '女性.', selected: false }, // 2
];

export const smsStatusOtp = [
  { id: STATUS_SMS_OTP.FAILED, value: 'SMSが送信できませんした（FAILED）.' },
  { id: STATUS_SMS_OTP.REJECTED, value: 'SMSが送信できませんした（REJECTED）.' },
  { id: STATUS_SMS_OTP.UNKNOWN, value: 'SMSが送信できませんした（UNKNOWN）.' },
];

export const textNameMemberDelete = '退会者.'


export const textTitleDefault = {
  MASTER_APP: 'Web HOME(Master-App)',
  GUNMA_JOB: 'Web HOME(Gunma-Job)',
  M_SYS_Online: 'Web HOME(M-SYS-Online)',
  FIND_PEOPLE: 'Web HOME(FInd-People)',
  BUILDING_TEST: 'Web HOME(Building-Test)',
};
export const contentDescriptionTagDefault = {
  MASTER_APP: 'Master-Appへのアクセスありがとうございます(Master-App))',
  GUNMA_JOB: 'Gunma-Jobへのアクセスありがとうございます(Gunma-Job)',
  M_SYS_Online: 'M-SYS-Onlineへのアクセスありがとうございます(M-SYS-Online)',
  FIND_PEOPLE: 'FInd-Peopleへのアクセスありがとうございます(FInd-People)',
  BUILDING_TEST : 'Building-Testへのアクセスありがとうございます(Building-Test)',
};

